// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.externaltour.RentalManagerUserPropertyExternalTourV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing,
  RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel,
  RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing,
  RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyExternalTourAddForListingResponseV2WebDto,
  UserPropertyExternalTourAddForListingV2RequestDto,
  UserPropertyExternalTourAddForModelResponseV2WebDto,
  UserPropertyExternalTourAddForModelV2RequestDto,
  UserPropertyExternalTourRemoveFromListingV2RequestDto,
  UserPropertyExternalTourRemoveFromModelV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Args {
  postData: UserPropertyExternalTourAddForListingV2RequestDto;
}

export type RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Options = UseMutationOptions<
  UserPropertyExternalTourAddForListingResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Args
>;

/**
 * Associate an external tour to a building/listing
 */
export const useRentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Args) =>
      RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Args {
  postData: UserPropertyExternalTourAddForModelV2RequestDto;
}

export type RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Options = UseMutationOptions<
  UserPropertyExternalTourAddForModelResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Args
>;

/**
 * Associate an external tour to a unit/floor plan
 */
export const useRentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Args) =>
      RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Args {
  postData: UserPropertyExternalTourRemoveFromListingV2RequestDto;
}

export type RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Args
  >;

/**
 * Remove an external tour from a building/listing
 */
export const useRentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Args) =>
      RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Args {
  postData: UserPropertyExternalTourRemoveFromModelV2RequestDto;
}

export type RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Args
  >;

/**
 * Remove an external tour from a unit/floor plan
 */
export const useRentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Args) =>
      RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel(args.postData, httpClient),
  });
};
